module.exports = __webpack_public_path__ + "img/user-minus.aae18478.svg";